<div class="warning-modal">
  <div class="container-fluid">
    <div class="text-container">
      <div class="text-container__img">
        <img src="../../../assets/images/icons/warning-icon.svg" />
      </div>
      <h1 class="title">{{ 'component.common.unsaved' | translate }}</h1>
      <div class="advise">
        <p>
          {{ 'component.common.unsaved-changes' | translate }}
        </p>
      </div>
    </div>
    <div class="row footer">
      <button class="clsCardButton cancel-button" (click)="closeModal()">
        {{ 'common.no' | translate }}
      </button>
      <button class="clsCardButton" (click)="continue()">
        {{ 'common.yes' | translate }}
      </button>
    </div>
  </div>
</div>
